import { connectedStore } from '../../store';
import site from '../../site';
// webpack can't resolve recursive dependencies in case if we import whole `integration` module
import getBlocks from '../selectors/blocks';
import isBlockDisabled from '../verifiers/is-block-disabled';
import canBeInsertedInto from '../verifiers/can-be-inserted-into';
import getBlockConstraint from '../selectors/block-constraint';

const findAllFor = (container, featureFlags) => {
  const store = connectedStore.get();
  const state = store.getState();
  const blocksList = getBlocks(state);
  const {
    hidden_blocks: isHiddenBlocksPermitted,
    contact_forms_disabled: isContactFormsBlockDisabled,
  } = featureFlags;
  const canBeInserted = canBeInsertedInto(container);

  const filteredBlocks = blocksList.filter((block) => {
    const constraint = getBlockConstraint(state, block.id);

    if (!constraint) return false;

    const { replaceable } = constraint;
    const isUniqueBlockPerPage = constraint.maxCount === 1;
    const canBeReplaced = isUniqueBlockPerPage && replaceable;

    if (block.hidden && !isHiddenBlocksPermitted) {
      return false;
    }

    // hack for TPG vCita partner
    if (isContactFormsBlockDisabled && block.tags.includes('form')) {
      return false;
    }

    if (isBlockDisabled(block) || (!canBeInserted(block.id) && !canBeReplaced)) {
      return false;
    }

    return container.matches(constraint.parent);
  });

  return filteredBlocks.map((block) => {
    const variations = block.variations.map((variation) => ({
      ...variation,
      preview: {
        ...variation.preview,
        source:
          variation.preview && variation.preview.source
            ? site.helpers.composeAssetUrl(variation.preview.source)
            : null,
      },
    }));

    return {
      ...block,
      variations,
    };
  });
};

export default findAllFor;
